<template>
  <div class="home-container10">
    <app-navigation></app-navigation>
    <section id="hero-section" class="hero-section">
      <div class="hero-video-container">
        <video src="https://vlecadblob.blob.core.windows.net/vlecad-website-mp4/Media/Sequence%2002%20(6).mp4" loop="true" muted="true" autoplay="true" playsinline="true" class="hero-video"></video>
        <div class="hero-overlay"></div>
      </div>
      <div class="hero-content">
        <div class="hero-badge">
          <svg width="16" xmlns="http://www.w3.org/2000/svg" height="16" viewBox="0 0 24 24">
            <path d="M4 14a1 1 0 0 1-.78-1.63l9.9-10.2a.5.5 0 0 1 .86.46l-1.92 6.02A1 1 0 0 0 13 10h7a1 1 0 0 1 .78 1.63l-9.9 10.2a.5.5 0 0 1-.86-.46l1.92-6.02A1 1 0 0 0 11 14z" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
          </svg>
          <span>{{ $t('home.hero.badge') }}</span>
        </div>
        <h1 class="hero-title">{{ $t('home.hero.title') }}</h1>
        <p class="home-thq-hero-subtitle-elm hero-subtitle">
          <span>{{ $t('home.hero.subtitleLine1') }}</span>
          <br />
          <span>{{ $t('home.hero.subtitleLine2') }}</span>
        </p>
        <div class="hero-cta-group">
          <router-link to="/contactdemo" class="home-thq-btn-elm1 btn btn-lg btn-primary">
            <button @click="scrollToTop">
              {{ $t('common.scheduleDemo') }}
            </button>
          </router-link>
          <a href="https://youtu.be/yiJ25jIXEcs" target="_blank" rel="noreferrer noopener" class="home-thq-btn-elm2 btn btn-lg btn-outline">
            <svg width="20" xmlns="http://www.w3.org/2000/svg" height="20" viewBox="0 0 24 24">
              <path d="M5 5a2 2 0 0 1 3.008-1.728l11.997 6.998a2 2 0 0 1 .003 3.458l-12 7A2 2 0 0 1 5 19z" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
            </svg>
            <span>{{ $t('home.hero.secondaryCta') }}</span>
          </a>
        </div>
        <div class="hero-trust-indicators">
          <div class="trust-item">
            <svg width="20" xmlns="http://www.w3.org/2000/svg" height="20" viewBox="0 0 24 24">
              <path d="M20 6L9 17l-5-5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
            </svg>
            <span>
              {{ $t('home.hero.trust.restApi') }}
            </span>
          </div>
          <div class="trust-item">
            <svg width="20" xmlns="http://www.w3.org/2000/svg" height="20" viewBox="0 0 24 24">
              <path d="M20 6L9 17l-5-5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
            </svg>
            <span>{{ $t('home.hero.trust.machines') }}</span>
          </div>
          <div class="trust-item">
            <svg width="20" xmlns="http://www.w3.org/2000/svg" height="20" viewBox="0 0 24 24">
              <path d="M20 6L9 17l-5-5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
            </svg>
            <span>{{ $t('home.hero.trust.lessErrors') }}</span>
          </div>
        </div>
      </div>
      <div class="hero-scroll-indicator">
        <span>Scroll</span>
        <div class="scroll-line"></div>
      </div>
    </section>
    <section id="trust-bar-section" class="home-thq-trust-bar-section-elm trust-bar-section">
      <div class="trust-bar-container">
        <p class="trust-bar-label">{{ $t('home.trustBar.label') }}
        </p>
        <div class="trust-bar-logos">
          <div class="trust-logo">
            <div class="logo-placeholder"><span>{{ $t('home.trustBar.logos.a') }}</span></div>
          </div>
          <div class="trust-logo">
            <div class="logo-placeholder"><span>{{ $t('home.trustBar.logos.b') }}</span></div>
          </div>
          <div class="trust-logo">
            <div class="logo-placeholder"><span>{{ $t('home.trustBar.logos.c') }}</span></div>
          </div>
          <div class="trust-logo">
            <div class="logo-placeholder"><span>{{ $t('home.trustBar.logos.d') }}</span></div>
          </div>
          <div class="trust-logo">
            <div class="logo-placeholder"><span>{{ $t('home.trustBar.logos.e') }}</span></div>
          </div>
          <div class="trust-logo">
            <div class="logo-placeholder"><span>{{ $t('home.trustBar.logos.f') }}</span></div>
          </div>
        </div>
      </div>
    </section>
    <section id="how-it-works-section" class="how-it-works-section">
      <div class="how-it-works-header">
        <span class="section-subtitle">{{ $t('home.howItWorks.subtitle') }}</span>
        <h2 class="section-title">{{ $t('home.howItWorks.title') }}</h2>
        <p class="section-content">{{ $t('home.howItWorks.description') }}</p>
      </div>
      <div class="timeline-container">
        <div class="home-thq-timeline-line-elm timeline-line"></div>
        <div class="timeline-step">
          <div class="timeline-number"><span>01</span></div>
          <div class="timeline-content">
            <div class="timeline-image-wrapper">
              <img
                alt="Carpenter working with laptop and tools in a modern workshop"
                src="/vlecad_170628_lr_78_sv5_1189-1500w.jpg"
                loading="lazy"
              />
            </div>
            <h3 class="timeline-title">{{ $t('home.howItWorks.steps.design.title') }}</h3>
            <p class="timeline-description">
              <span>{{ $t('home.howItWorks.steps.design.leadLine1') }}</span>
              <br />
              <span>{{ $t('home.howItWorks.steps.design.leadLine2') }}</span>
            </p>
            <ul class="timeline-features">
              <li>
                <svg width="16" xmlns="http://www.w3.org/2000/svg" height="16" viewBox="0 0 24 24">
                  <path d="M20 6L9 17l-5-5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                </svg>
                <span>{{ $t('home.howItWorks.steps.design.features.library') }}</span>
              </li>
              <li>
                <svg width="16" xmlns="http://www.w3.org/2000/svg" height="16" viewBox="0 0 24 24">
                  <path d="M20 6L9 17l-5-5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                </svg>
                <span>{{ $t('home.howItWorks.steps.design.features.connections') }}</span>
              </li>
              <li>
                <svg width="16" xmlns="http://www.w3.org/2000/svg" height="16" viewBox="0 0 24 24">
                  <path d="M20 6L9 17l-5-5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                </svg>
                <span>{{ $t('home.howItWorks.steps.design.features.production') }}</span>
              </li>
            </ul>
          </div>
        </div>
        <div class="timeline-step">
          <div class="timeline-number"><span>02</span></div>
          <div class="timeline-content">
            <div class="timeline-image-wrapper">
              <img
                alt="CNC machine cutting wooden panel with precision"
                src="https://images.pexels.com/photos/7480234/pexels-photo-7480234.jpeg?auto=compress&amp;cs=tinysrgb&amp;h=650&amp;w=940"
                loading="lazy"
              />
              <div class="timeline-image-overlay">
                <img
                  alt="image"
                  src="/vlecad_170628_lr_40_sv5_0677-600w.jpg"
                  class="home-image12"
                />
              </div>
            </div>
            <h3 class="timeline-title">{{ $t('home.howItWorks.steps.automate.title') }}</h3>
            <p class="timeline-description">
              <span>{{ $t('home.howItWorks.steps.automate.leadLine1') }}</span>
              <br />
              <span>{{ $t('home.howItWorks.steps.automate.leadLine2') }}</span>
            </p>
            <ul class="timeline-features">
              <li>
                <svg width="16" xmlns="http://www.w3.org/2000/svg" height="16" viewBox="0 0 24 24">
                  <path d="M20 6L9 17l-5-5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                </svg>
                <span>{{ $t('home.howItWorks.steps.automate.features.cuttingLists') }}</span>
              </li>
              <li>
                <svg width="16" xmlns="http://www.w3.org/2000/svg" height="16" viewBox="0 0 24 24" >
                  <path d="M20 6L9 17l-5-5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                </svg>
                <span>{{ $t('home.howItWorks.steps.automate.features.nesting') }}</span>
              </li>
              <li>
                <svg width="16" xmlns="http://www.w3.org/2000/svg" height="16" viewBox="0 0 24 24">
                  <path d="M20 6L9 17l-5-5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                </svg>
                <span>{{ $t('home.howItWorks.steps.automate.features.bom') }}</span>
              </li>
            </ul>
          </div>
        </div>
        <div class="timeline-step">
          <div class="timeline-number"><span>03</span></div>
          <div class="timeline-content">
            <div class="timeline-image-wrapper">
              <img
                alt="CNC machine operating in workshop with technician"
                src="https://images.pexels.com/photos/9242202/pexels-photo-9242202.jpeg?auto=compress&amp;cs=tinysrgb&amp;h=650&amp;w=940"
                loading="lazy"
              />
              <div class="timeline-image-overlay">
                <img
                  alt="image"
                  src="/vlecad_170628_lr_45_sv5_0834-600w.jpg"
                  class="home-image14"
                />
              </div>
            </div>
            <h3 class="timeline-title">{{ $t('home.howItWorks.steps.sendToNc.title') }}</h3>
            <p class="timeline-description">{{ $t('home.howItWorks.steps.sendToNc.description') }}</p>
            <ul class="timeline-features">
              <li>
                <svg width="16" xmlns="http://www.w3.org/2000/svg" height="16" viewBox="0 0 24 24">
                  <path d="M20 6L9 17l-5-5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                </svg>
                <span>{{ $t('home.howItWorks.steps.sendToNc.features.integration') }}</span>
              </li>
              <li>
                <svg width="16" xmlns="http://www.w3.org/2000/svg" height="16" viewBox="0 0 24 24">
                  <path d="M20 6L9 17l-5-5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                </svg>
                <span>{{ $t('home.howItWorks.steps.sendToNc.features.postprocessors') }}</span>
              </li>
            </ul>
          </div>
        </div>
        <div class="timeline-step">
          <div class="timeline-number"><span>04</span></div>
          <div class="timeline-content">
            <div class="timeline-image-wrapper">
              <img
                alt="Wooden furniture assembly with precise dowel pins"
                src="https://images.pexels.com/photos/702146/pexels-photo-702146.jpeg?auto=compress&amp;cs=tinysrgb&amp;h=650&amp;w=940"
                loading="lazy"
              />
              <div class="timeline-image-overlay">
                <img
                  alt="image"
                  src="/vlecad_170628_lr_56_sv5_0897-600w.jpg"
                  class="home-image16"
                />
              </div>
            </div>
            <h3 class="timeline-title">{{ $t('home.howItWorks.steps.send.title') }}</h3>
            <p class="timeline-description">
              <span>{{ $t('home.howItWorks.steps.send.leadLine1') }}</span>
              <br />
              <span>{{ $t('home.howItWorks.steps.send.leadLine2') }}</span>
            </p>
            <ul class="timeline-features">
              <li>
                <svg width="16" xmlns="http://www.w3.org/2000/svg" height="16" viewBox="0 0 24 24">
                  <path d="M20 6L9 17l-5-5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                </svg>
                <span>{{ $t('home.howItWorks.steps.send.features.labels') }}</span>
              </li>
              <li>
                <svg width="16" xmlns="http://www.w3.org/2000/svg" height="16" viewBox="0 0 24 24">
                  <path d="M20 6L9 17l-5-5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                </svg>
                <span>{{ $t('home.howItWorks.steps.send.features.instructions') }}</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
    <div>
      <section id="features-section" class="features-section">
        <div class="features-header">
          <span class="section-subtitle">{{ $t('home.features.subtitle') }}</span>
          <h2 class="section-title">{{ $t('home.features.title') }}</h2>
        </div>
        <div class="features-grid">
          <div class="feature-card-large feature-card">
            <div class="feature-image-container">
              <img alt="Modern CNC machine control panel for precision" src="https://images.pexels.com/photos/18471450/pexels-photo-18471450.jpeg?auto=compress&amp;cs=tinysrgb&amp;h=650&amp;w=940" loading="lazy"/>
              <div class="feature-image-overlay">
                <img alt="image" src="/vlecad_170628_lr_71_sv5_1103-400w.jpg" class="home-image18"/>
              </div>
            </div>
            <div class="feature-icon">
              <svg width="24" xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24">
                <path d="M4 14a1 1 0 0 1-.78-1.63l9.9-10.2a.5.5 0 0 1 .86.46l-1.92 6.02A1 1 0 0 0 13 10h7a1 1 0 0 1 .78 1.63l-9.9 10.2a.5.5 0 0 1-.86-.46l1.92-6.02A1 1 0 0 0 11 14z"
                  fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
              </svg>
            </div>
            <h3 class="feature-title">{{ $t('home.features.cards.parametric.title') }}</h3>
            <p class="feature-description">{{ $t('home.features.cards.parametric.description') }}
            </p>
          </div>
          <div class="feature-card">
            <div class="feature-icon">
              <svg width="24" xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24">
                <g fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M12 20v2m0-20v2m5 16v2m0-20v2M2 12h2m-2 5h2M2 7h2m16 5h2m-2 5h2M20 7h2M7 20v2M7 2v2"></path>
                  <rect x="4" y="4" rx="2" width="16" height="16"></rect>
                  <rect x="8" y="8" rx="1" width="8" height="8"></rect>
                </g>
              </svg>
            </div>
            <h3 class="feature-title">{{ $t('home.features.cards.oneClick.title') }}</h3>
            <p class="feature-description">{{ $t('home.features.cards.oneClick.description') }}
            </p>
          </div>
          <div class="feature-card">
            <div class="feature-icon">
              <svg width="24" xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24">
                <g fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M12.83 2.18a2 2 0 0 0-1.66 0L2.6 6.08a1 1 0 0 0 0 1.83l8.58 3.91a2 2 0 0 0 1.66 0l8.58-3.9a1 1 0 0 0 0-1.83z"></path>
                  <path d="M2 12a1 1 0 0 0 .58.91l8.6 3.91a2 2 0 0 0 1.65 0l8.58-3.9A1 1 0 0 0 22 12"></path>
                  <path d="M2 17a1 1 0 0 0 .58.91l8.6 3.91a2 2 0 0 0 1.65 0l8.58-3.9A1 1 0 0 0 22 17"></path>
                </g>
              </svg>
            </div>
            <h3 class="feature-title">{{ $t('home.features.cards.materials.title') }}</h3>
            <p class="feature-description">{{ $t('home.features.cards.materials.description') }}</p>
          </div>
          <div class="feature-card">
            <div class="feature-icon">
              <svg width="24" xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24">
                <g fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M21 8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16Z"></path>
                  <path d="m3.3 7l8.7 5l8.7-5M12 22V12"></path>
                </g>
              </svg>
            </div>
            <h3 class="feature-title">{{ $t('home.features.cards.hardware.title') }}</h3>
            <p class="feature-description">{{ $t('home.features.cards.hardware.description') }}
            </p>
          </div>
          <div class="feature-card">
            <div class="feature-icon">
              <svg width="24" xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24">
                <g fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M12 6v6l4 2"></path>
                  <circle r="10" cx="12" cy="12"></circle>
                </g>
              </svg>
            </div>
            <h3 class="feature-title">{{ $t('home.features.cards.batch.title') }}</h3>
            <p class="feature-description">{{ $t('home.features.cards.batch.description') }}</p>
          </div>
        </div>
        <router-link to="/product">
          <div class="home-thq-features-cta-elm features-cta">
            <button class="btn btn-lg btn-secondary">{{ $t('home.features.cta') }}</button>
          </div>
        </router-link>
      </section>
    </div>
    <div>
      <section id="compatibility-section" class="compatibility-section">
        <div class="compatibility-content">
          <div class="compatibility-text">
            <span class="section-subtitle">{{ $t('home.compatibility.subtitle') }}</span>
            <h2 class="section-title">{{ $t('home.compatibility.title') }}</h2>
            <p class="section-content">
              <span>{{ $t('home.compatibility.descriptionLine1') }}</span>
              <br />
              <span>{{ $t('home.compatibility.descriptionLine2') }}</span>
            </p>
            <div class="compatibility-features">
              <div class="compatibility-feature">
                <svg width="20" xmlns="http://www.w3.org/2000/svg" height="20" viewBox="0 0 24 24">
                  <path d="M20 6L9 17l-5-5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                </svg>
                <div>
                  <h4>{{ $t('home.compatibility.features.brands.title') }}</h4>
                  <p>{{ $t('home.compatibility.features.brands.description') }}</p>
                </div>
              </div>
              <div class="compatibility-feature">
                <svg width="20" xmlns="http://www.w3.org/2000/svg" height="20" viewBox="0 0 24 24">
                  <path d="M20 6L9 17l-5-5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                </svg>
                <div>
                  <h4>{{ $t('home.compatibility.features.nesting.title') }}</h4>
                  <p>{{ $t('home.compatibility.features.nesting.description') }}</p>
                </div>
              </div>
              <div class="compatibility-feature">
                <svg width="20" xmlns="http://www.w3.org/2000/svg" height="20" viewBox="0 0 24 24">
                  <path d="M20 6L9 17l-5-5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                </svg>
                <div>
                  <h4>{{ $t('home.compatibility.features.storage.title') }}</h4>
                  <p>{{ $t('home.compatibility.features.storage.description') }}</p>
                </div>
              </div>
              <div class="compatibility-feature">
                <svg width="20" xmlns="http://www.w3.org/2000/svg" height="20" viewBox="0 0 24 24">
                  <path d="M20 6L9 17l-5-5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                </svg>
                <div>
                  <h4>{{ $t('home.compatibility.features.api.title') }}</h4>
                  <p>{{ $t('home.compatibility.features.api.description') }}</p>
                </div>
              </div>
            </div>
            <router-link to="/integrations" class="home-thq-btn-elm5 btn btn-lg btn-primary">
              {{ $t('home.compatibility.cta') }}
            </router-link>
          </div>
          <div class="compatibility-visual">
            <div class="compatibility-image-main">
              <img alt="CNC machine being operated in workshop" src="https://images.pexels.com/photos/9242907/pexels-photo-9242907.jpeg?auto=compress&amp;cs=tinysrgb&amp;h=650&amp;w=940" loading="lazy"/>
              <div class="compatibility-badge">
                <svg width="24" xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24">
                  <path d="M20 6L9 17l-5-5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                </svg>
                <span>{{ $t('home.compatibility.badge') }}</span>
              </div>
            </div>
            <div class="home-thq-compatibility-brands1-elm1 compatibility-brands1">
              <div class="brand-item22 brand-item1">
                <img alt="image" src="/homag-1-200h.png" class="image2" />
              </div>
              <div class="brand-item21 brand-item22">
                <img alt="image" src="/biesse-logo-articolo-200h.png" class="home-thq-image3-elm1 image3"/>
              </div>
              <div class="brand-item3 brand-item22">
                <img alt="image" src="/scm%20group%201-200h.png" class="image4" />
              </div>
              <div class="brand-item4 brand-item22">
                <img alt="image" src="/holzher-logo-200h.png" class="home-thq-image5-elm1 image5 image"/>
              </div>
            </div>
            <div>
              <div class="home-thq-compatibility-brands1-elm2 compatibility-brands1">
                <div class="brand-item22 brand-item1">
                  <img alt="image" src="/ima%20schelling-200h.png" class="image2"/>
                </div>
                <div class="brand-item21 brand-item22">
                  <img alt="image" src="/logo-feldergroup-200h.png" class="home-thq-image3-elm2 image3"/>
                </div>
                <div class="brand-item3 brand-item22">
                  <img alt="image" src="/gannomat-200h.png" class="image4" />
                </div>
                <div class="brand-item4 brand-item22">
                  <img alt="image" src="/aes-200h.png" class="home-thq-image5-elm2 image5 image"/>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
    <div>
      <section id="roi-section" class="roi-section">
        <div class="roi-container">
          <div class="roi-header">
            <span class="section-subtitle">{{ $t('home.roi.subtitle') }}</span>
            <h2 class="section-title">{{ $t('home.roi.title') }}</h2>
            <p class="section-content">{{ $t('home.roi.description') }}
            </p>
          </div>
          <div class="roi-metrics">
            <div class="roi-metric">
              <div class="roi-metric-icon">
                <svg width="32" xmlns="http://www.w3.org/2000/svg" height="32" viewBox="0 0 24 24">
                  <g fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M12 6v6l4 2"></path>
                    <circle r="10" cx="12" cy="12"></circle>
                  </g>
                </svg>
              </div>
              <div class="roi-metric-value"><span>75%</span></div>
              <div class="roi-metric-label">
                <span>{{ $t('home.roi.metrics.time.label') }}</span>
              </div>
              <p class="roi-metric-description">
                {{ $t('home.roi.metrics.time.description') }}
              </p>
            </div>
            <div class="roi-metric">
              <div class="roi-metric-icon">
                <svg width="32" xmlns="http://www.w3.org/2000/svg" height="32" viewBox="0 0 24 24">
                  <g fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M16 7h6v6"></path>
                    <path d="m22 7l-8.5 8.5l-5-5L2 17"></path>
                  </g>
                </svg>
              </div>
              <div class="roi-metric-value"><span>40%</span></div>
              <div class="roi-metric-label">
                <span>{{ $t('home.roi.metrics.capacity.label') }}</span>
              </div>
              <p class="roi-metric-description">
                {{ $t('home.roi.metrics.capacity.description') }}
              </p>
            </div>
            <div class="roi-metric">
              <div class="roi-metric-icon">
                <svg width="32" xmlns="http://www.w3.org/2000/svg" height="32" viewBox="0 0 24 24">
                  <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"
                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                </svg>
              </div>
              <div class="roi-metric-value"><span>90%</span></div>
              <div class="roi-metric-label">
                <span>{{ $t('home.roi.metrics.errors.label') }}</span>
              </div>
              <p class="roi-metric-description">
                {{ $t('home.roi.metrics.errors.description') }}
              </p>
            </div>
            <div class="roi-metric">
              <div class="roi-metric-icon">
                <svg width="32" xmlns="http://www.w3.org/2000/svg" height="32" viewBox="0 0 24 24">
                  <g fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <circle r="10" cx="12" cy="12"></circle>
                    <circle r="6" cx="12" cy="12"></circle>
                    <circle r="2" cx="12" cy="12"></circle>
                  </g>
                </svg>
              </div>
              <div class="roi-metric-value"><span>8-10</span></div>
              <div class="roi-metric-label"><span>{{ $t('home.roi.metrics.weeks.label') }}</span></div>
              <p class="roi-metric-description">
                {{ $t('home.roi.metrics.weeks.description') }}
              </p>
            </div>
          </div>
          <div class="roi-calculator">
            <div class="roi-calculator-content">
              <h3>{{ $t('home.roi.calculator.title') }}</h3>
              <p>{{ $t('home.roi.calculator.description') }}
              </p>
              <router-link to="/contactdemo" class="home-thq-btn-elm6 btn btn-lg btn-primary">
                <button @click="scrollToTop">
                  {{ $t('home.roi.calculator.cta') }}
                </button>
              </router-link>
            </div>
            <div class="roi-calculator-visual">
              <img alt="Female woodworker measuring wood in workshop" src="https://images.pexels.com/photos/6790030/pexels-photo-6790030.jpeg?auto=compress&amp;cs=tinysrgb&amp;h=650&amp;w=940" loading="lazy"/>
            </div>
          </div>
        </div>
      </section>
    </div>
    <div>
      <section id="testimonials-section" class="testimonials-section">
        <div class="testimonials-header">
          <span class="section-subtitle">{{ $t('home.testimonials.subtitle') }}</span>
          <h2 class="section-title">{{ $t('home.testimonials.title') }}</h2>
        </div>
        <div class="testimonials-grid">
          <div class="testimonial-card">
            <div class="testimonial-quote-icon">
              <svg width="40" xmlns="http://www.w3.org/2000/svg" height="40" viewBox="0 0 24 24">
                <path d="M16 3a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2a1 1 0 0 1 1 1v1a2 2 0 0 1-2 2a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1a6 6 0 0 0 6-6V5a2 2 0 0 0-2-2zM5 3a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2a1 1 0 0 1 1 1v1a2 2 0 0 1-2 2a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1a6 6 0 0 0 6-6V5a2 2 0 0 0-2-2z"
                  fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
              </svg>
            </div>
            <p class="testimonial-text">{{ $t('home.testimonials.cards.first.quote') }}
            </p>
            <div class="testimonial-author">
              <div class="testimonial-author-image">
                <img alt="Worker in workshop with CNC machine" src="https://images.pexels.com/photos/9242203/pexels-photo-9242203.jpeg?auto=compress&amp;cs=tinysrgb&amp;h=650&amp;w=940" loading="lazy"/>
              </div>
              <div class="testimonial-author-info">
                <div class="testimonial-author-name">
                  <span>Pieter Van den Berg</span>
                </div>
                <div class="testimonial-author-role">
                  <span>{{ $t('home.testimonials.cards.first.role') }}</span>
                </div>
              </div>
            </div>
            <div class="testimonial-metrics">
              <div class="testimonial-metric">
                <span class="metric-value">40%</span>
                <span class="metric-label">{{ $t('home.testimonials.cards.first.metric1') }}</span>
              </div>
              <div class="testimonial-metric">
                <span class="metric-value">85%</span>
                <span class="metric-label">{{ $t('home.testimonials.cards.first.metric2') }}</span>
              </div>
            </div>
          </div>
          <div class="testimonial-card">
            <div class="testimonial-quote-icon">
              <svg width="40" xmlns="http://www.w3.org/2000/svg" height="40" viewBox="0 0 24 24">
                <path d="M16 3a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2a1 1 0 0 1 1 1v1a2 2 0 0 1-2 2a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1a6 6 0 0 0 6-6V5a2 2 0 0 0-2-2zM5 3a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2a1 1 0 0 1 1 1v1a2 2 0 0 1-2 2a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1a6 6 0 0 0 6-6V5a2 2 0 0 0-2-2z"
                  fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
              </svg>
            </div>
            <p class="testimonial-text">{{ $t('home.testimonials.cards.second.quote') }}
            </p>
            <div class="testimonial-author">
              <div class="testimonial-author-image">
                <img alt="Technician working with CNC machine" src="https://images.pexels.com/photos/9242167/pexels-photo-9242167.jpeg?auto=compress&amp;cs=tinysrgb&amp;h=650&amp;w=940" loading="lazy"/>
              </div>
              <div class="testimonial-author-info">
                <div class="testimonial-author-name">
                  <span>Sophie Janssen</span>
                </div>
                <div class="testimonial-author-role">
                  <span>{{ $t('home.testimonials.cards.second.role') }}</span>
                </div>
              </div>
            </div>
            <div class="testimonial-metrics">
              <div class="testimonial-metric">
                <span class="metric-value">60%</span>
                <span class="metric-label">{{ $t('home.testimonials.cards.second.metric1') }}</span>
              </div>
              <div class="testimonial-metric">
                <span class="metric-value">30%</span>
                <span class="metric-label">{{ $t('home.testimonials.cards.second.metric2') }}</span>
              </div>
            </div>
          </div>
          <div class="testimonial-card">
            <div class="testimonial-quote-icon">
              <svg width="40" xmlns="http://www.w3.org/2000/svg" height="40" viewBox="0 0 24 24">
                <path d="M16 3a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2a1 1 0 0 1 1 1v1a2 2 0 0 1-2 2a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1a6 6 0 0 0 6-6V5a2 2 0 0 0-2-2zM5 3a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2a1 1 0 0 1 1 1v1a2 2 0 0 1-2 2a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1a6 6 0 0 0 6-6V5a2 2 0 0 0-2-2z"
                  fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
              </svg>
            </div>
            <p class="testimonial-text">{{ $t('home.testimonials.cards.third.quote') }}
            </p>
            <div class="testimonial-author">
              <div class="testimonial-author-image">
                <img alt="Carpenter using hand plane on wooden plank" src="https://images.pexels.com/photos/5974239/pexels-photo-5974239.jpeg?auto=compress&amp;cs=tinysrgb&amp;h=650&amp;w=940" loading="lazy"/>
              </div>
              <div class="testimonial-author-info">
                <div class="testimonial-author-name">
                  <span>Mark De Vries</span>
                </div>
                <div class="testimonial-author-role">
                  <span>{{ $t('home.testimonials.cards.third.role') }}</span>
                </div>
              </div>
            </div>
            <div class="testimonial-metrics">
              <div class="testimonial-metric">
                <span class="metric-value">3x</span>
                <span class="metric-label">{{ $t('home.testimonials.cards.third.metric1') }}</span>
              </div>
              <div class="testimonial-metric">
                <span class="metric-value">100%</span>
                <span class="metric-label">{{ $t('home.testimonials.cards.third.metric2') }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="testimonials-cta">
          <router-link to="/customerstories" class="home-thq-btn-elm7 btn btn-lg btn-secondary">
            <button @click="scrollToTop">
              {{ $t('home.testimonials.cta') }}
            </button>
          </router-link>
        </div>
      </section>
    </div>
    <section id="final-cta-section" class="final-cta-section">
      <div class="final-cta-video-container">
        <video src="https://vlecadblob.blob.core.windows.net/vlecad-website-mp4/Media/Sequence%2002%20(6).mp4" loop="true" muted="true" autoplay="true" playsinline="true" class="final-cta-video"></video>
        <div><div class="final-cta-overlay"></div></div>
      </div>
      <div>
        <div class="final-cta-content">
          <h2 class="final-cta-title">{{ $t('home.finalCta.title') }}</h2>
          <p class="final-cta-subtitle">{{ $t('home.finalCta.subtitle') }}
          </p>
          <div class="final-cta-benefits">
            <div class="final-cta-benefit">
              <svg width="20" xmlns="http://www.w3.org/2000/svg" height="20" viewBox="0 0 24 24">
                <path d="M20 6L9 17l-5-5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
              </svg>
              <span>{{ $t('home.finalCta.benefits.personalized') }}</span>
            </div>
            <div class="final-cta-benefit">
              <svg width="20" xmlns="http://www.w3.org/2000/svg" height="20" viewBox="0 0 24 24">
                <path d="M20 6L9 17l-5-5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
              </svg>
              <span>{{ $t('home.finalCta.benefits.roi') }}</span>
            </div>
            <div class="final-cta-benefit">
              <svg width="20" xmlns="http://www.w3.org/2000/svg" height="20" viewBox="0 0 24 24">
                <path d="M20 6L9 17l-5-5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
              </svg>
              <span>{{ $t('home.finalCta.benefits.noObligations') }}</span>
            </div>
          </div>
          <p class="home-thq-final-cta-footer-elm final-cta-footer">
            <span>Or call directly:</span>
            <a href="tel:+3289819330">
              <div>
                <div><span>+32 (0)89 81 93 30</span></div>
              </div>
            </a>
            <span>·</span>
            <a href="mailto:info@vlecad.com">
              <div>
                <div><span>info@vlecad.com</span></div>
              </div>
            </a>
          </p>
        </div>
      </div>
    </section>
    <app-footer></app-footer>
  </div>
</template>

<script>
import { useHead } from '@vueuse/head'

import AppNavigation from '../components/navigation'
import AppFooter from '../components/footer'

export default {
  name: 'Home',
  props: {},
  components: {
    AppNavigation,
    AppFooter,
  },
  setup() {
    // Vue 3 migration: move metaInfo into useHead.
    useHead({
      title: 'KORPUS by VLECAD®',
      meta: [
        {
          name: 'description',
          content:
            'KORPUS by VLECAD®: From design to CNC in one click. CAD/CAM that thinks like a craftsman for interior builders and cabinet shops. Book a demo.',
        },
        {
          property: 'og:title',
          content: 'KORPUS by VLECAD®',
        },
        {
          property: 'og:description',
          content:
            'KORPUS by VLECAD®: From design to CNC in one click. CAD/CAM that thinks like a craftsman for interior builders and cabinet shops. Book a demo.',
        },
        {
          property: 'og:image',
          content:
            'https://aheioqhobo.cloudimg.io/v7/_playground-bucket-v2.teleporthq.io_/ebedf48f-c2b5-4ca6-808d-9d940905bddf/993061ae-1787-4b73-9fda-47262adc60d9?org_if_sml=1&force_format=original',
        },
      ],
      link: [
        {
          rel: 'canonical',
          href: 'https://hospitable-imperfect-heron-qlicxu.teleporthq.app/',
        },
      ],
    })
  },
  mounted() {
    // Vue 3 migration/security: replace injected scripts with lifecycle hooks.
    const observerOptions = {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px',
    }

    const fadeInObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.style.opacity = '0'
          entry.target.style.transform = 'translateY(30px)'

          setTimeout(() => {
            entry.target.style.transition =
              'opacity 0.8s ease-out, transform 0.8s ease-out'
            entry.target.style.opacity = '1'
            entry.target.style.transform = 'translateY(0)'
          }, 100)

          fadeInObserver.unobserve(entry.target)
        }
      })
    }, observerOptions)

    const timelineSteps = document.querySelectorAll('.timeline-step')
    timelineSteps.forEach((step) => fadeInObserver.observe(step))

    const featureCards = document.querySelectorAll('.feature-card')
    featureCards.forEach((card) => fadeInObserver.observe(card))

    const roiMetrics = document.querySelectorAll('.roi-metric')
    roiMetrics.forEach((metric) => fadeInObserver.observe(metric))

    const testimonialCards = document.querySelectorAll('.testimonial-card')
    testimonialCards.forEach((card) => fadeInObserver.observe(card))

    const submitDemoBtn = document.getElementById('submit-demo-btn')
    const handleSubmit = (event) => {
      event.preventDefault()

      const name = document.getElementById('cta-name').value.trim()
      const company = document.getElementById('cta-company').value.trim()
      const email = document.getElementById('cta-email').value.trim()
      const phone = document.getElementById('cta-phone').value.trim()
      const machines = document.getElementById('cta-machines').value.trim()
      const message = document.getElementById('cta-message').value.trim()

      if (!name || !company || !email || !phone) {
        alert('Vul alstublieft alle verplichte velden in.')
        return
      }

      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
      if (!emailRegex.test(email)) {
        alert('Voer een geldig e-mailadres in.')
        return
      }

      submitDemoBtn.textContent = 'Demo aanvraag verzonden!'
      submitDemoBtn.disabled = true

      setTimeout(() => {
        document.getElementById('cta-name').value = ''
        document.getElementById('cta-company').value = ''
        document.getElementById('cta-email').value = ''
        document.getElementById('cta-phone').value = ''
        document.getElementById('cta-machines').value = ''
        document.getElementById('cta-message').value = ''
        submitDemoBtn.textContent = 'Plan een demo'
        submitDemoBtn.disabled = false
      }, 3000)

      console.log('Demo request:', {
        name,
        company,
        email,
        phone,
        machines,
        message,
      })
    }
    if (submitDemoBtn) {
      submitDemoBtn.addEventListener('click', handleSubmit)
    }

    const heroSection = document.getElementById('hero-section')
    const heroVideo = document.querySelector('.hero-video')
    const handleHeroScroll = () => {
      const scrolled = window.pageYOffset
      const rate = scrolled * 0.3

      if (scrolled < window.innerHeight && heroVideo) {
        heroVideo.style.transform = `translate(-50%, calc(-50% + ${rate}px))`
      }
    }

    if (heroSection && heroVideo) {
      window.addEventListener('scroll', handleHeroScroll)
    }

    const animateValue = (element, start, end, duration) => {
      let startTimestamp = null
      const step = (timestamp) => {
        if (!startTimestamp) startTimestamp = timestamp
        const progress = Math.min((timestamp - startTimestamp) / duration, 1)
        const value = Math.floor(progress * (end - start) + start)
        element.textContent = value + (element.dataset.suffix || '')
        if (progress < 1) {
          window.requestAnimationFrame(step)
        }
      }
      window.requestAnimationFrame(step)
    }

    const roiMetricObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const valueElement = entry.target.querySelector('.roi-metric-value')
          if (valueElement && !valueElement.dataset.animated) {
            const text = valueElement.textContent
            const match = text.match(/(\\d+)/)
            if (match) {
              const targetValue = parseInt(match[1], 10)
              valueElement.dataset.suffix = text.replace(/\\d+/, '')
              valueElement.textContent = `0${valueElement.dataset.suffix}`
              animateValue(valueElement, 0, targetValue, 2000)
              valueElement.dataset.animated = 'true'
            }
          }
          roiMetricObserver.unobserve(entry.target)
        }
      })
    }, observerOptions)

    roiMetrics.forEach((metric) => roiMetricObserver.observe(metric))

    const trustLogos = document.querySelectorAll('.trust-logo')
    trustLogos.forEach((logo, index) => {
      logo.style.opacity = '0'
      logo.style.transform = 'translateY(20px)'

      setTimeout(() => {
        logo.style.transition = 'opacity 0.5s ease-out, transform 0.5s ease-out'
        logo.style.opacity = '0.6'
        logo.style.transform = 'translateY(0)'
      }, 100 * index)
    })

    this._cleanupHome = () => {
      fadeInObserver.disconnect()
      roiMetricObserver.disconnect()
      if (submitDemoBtn) {
        submitDemoBtn.removeEventListener('click', handleSubmit)
      }
      window.removeEventListener('scroll', handleHeroScroll)
    }
  },
  beforeUnmount() {
    if (this._cleanupHome) {
      this._cleanupHome()
    }
  },
  data() {
    return {
    }
  },
  methods: {
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }    
  }
}
</script>

<style>
@keyframes badge-float {
  0%,
  100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-8px);
  }
}
@keyframes scroll-pulse {
  0%,
  100% {
    opacity: 0.3;
    transform: translateY(0);
  }
  50% {
    opacity: 1;
    transform: translateY(8px);
  }
}
@keyframes pulse-ring {
  0% {
    opacity: 0.8;
    transform: scale(1);
  }
  100% {
    opacity: 0;
    transform: scale(1.3);
  }
}
* {
  transition: background-color 0.3s var(--animation-curve-primary),
    border-color 0.3s var(--animation-curve-primary),
    color 0.3s var(--animation-curve-primary);
}
</style>

<style scoped>
.home-container10 {
  width: 100%;
  display: block;
  min-height: 100vh;
}
 
.home-container11 {
  display: none;
}
 
.home-container12 {
  display: contents;
}
 
.home-container13 {
  display: none;
}
 
.home-container14 {
  display: contents;
}
 
.home-container15 {
  display: none;
}
 
.home-container16 {
  display: contents;
}
 
.home-thq-hero-subtitle-elm {
  color: rgb(0, 0, 0);
}
 
.home-thq-btn-elm1 {
  text-decoration: none;
}
 
.home-thq-btn-elm2 {
  text-decoration: none;
}
 
.home-thq-trust-bar-section-elm {
  display: none;
}
 
.home-thq-timeline-line-elm {
  display: none;
}
 
.home-image12 {
  width: 554px;
  object-fit: cover;
}
 
.home-image14 {
  width: 570px;
  object-fit: cover;
}
 
.home-image16 {
  width: 553px;
  object-fit: cover;
}
 
.home-thq-btn-elm3 {
  text-decoration: none;
}
 
.home-image18 {
  width: 352px;
  object-fit: cover;
}
 
.home-thq-features-cta-elm {
  text-decoration: none;
}
 
.home-thq-btn-elm5 {
  text-decoration: none;
}
 
.home-thq-compatibility-brands1-elm1 {
  margin-right: -4px;
}
 
.home-thq-image3-elm1 {
  top: 0px;
  bottom: 0px;
  margin: auto;
}
 
.home-thq-image5-elm1 {
  top: 0px;
  bottom: 0px;
  margin: auto;
}
 
.home-thq-compatibility-brands1-elm2 {
  margin-top: 0px;
  margin-left: -4px;
  margin-right: 0px;
  margin-bottom: 0px;
}
 
.home-thq-image3-elm2 {
  top: 0px;
  bottom: 0px;
  margin: auto;
}
 
.home-thq-image5-elm2 {
  top: 0px;
  bottom: 0px;
  margin: auto;
}
 
.home-thq-btn-elm6 {
  text-decoration: none;
}
 
.home-thq-btn-elm7 {
  text-decoration: none;
}
 
.home-thq-final-cta-footer-elm {
  display: none;
}
 
@media(max-width: 479px) {
  .home-thq-image5-elm1 {
    top: 0px;
    bottom: 0px;
    margin: auto;
  }
  .home-thq-image5-elm2 {
    top: 0px;
    bottom: 0px;
    margin: auto;
  }
}
</style>
